import React, { Component, Suspense, lazy } from 'react';

import NotFound from '../common/NotFound';
import LoadingIndicator from '../common/LoadingIndicator';
import { getCurrentUser } from '../util/APIUtils';
import Layout from '../common/layout';
import { Redirect, Route, Switch } from 'react-router';
import { allow2Oauth, allowRegister } from '../constants/config';

// Route components are code-split so the initial bundle only ships what the
// landing route (/login) needs; other routes load on demand.
const LoginLayout = lazy(() => import('../user/login'));
const LoginV2 = lazy(() => import('../user/login/LoginV2'));
const OAuthCallback = lazy(() => import('../user/login/OAuthCallback'));
const SignupSuccess = lazy(() => import('../user/signup/signupSuccess'));
const ActiveAccount = lazy(() => import('../user/active/Active'));
const CreateOrg = lazy(() => import('../user/signup/CreateOrg'));
const AcceptInvite = lazy(() => import('../user/invite/AcceptInvite'));
const ChangeEmail = lazy(() => import('../user/change-email/ChangeEmail'));
const ChangePassword = lazy(() => import('../user/change-password/ChangePassword'));
const ForgotPassWord = lazy(() => import('../user/forgotPassword/ForgotPassword'));
const Signup = lazy(() => import('../user/signup/Signup'));
const OAuth2RedirectHandler = lazy(() => import('../user/oauth2/OAuth2RedirectHandler'));

class App extends Component {
  constructor (props) {
    super(props);
    this.state = {
      authenticated: false,
      currentUser: null,
      loading: true
    };

    this.loadCurrentlyLoggedInUser = this.loadCurrentlyLoggedInUser.bind(this);
  }

  loadCurrentlyLoggedInUser() {
    getCurrentUser()
      .then(response => {
        this.setState({
          currentUser: response,
          authenticated: true,
          loading: false
        });
      }).catch(() => {
        this.setState({
          loading: false
        });
      });
  }

  componentDidMount() {
    this.loadCurrentlyLoggedInUser();
  }

  render() {
    if (this.state.loading) {
      return <LoadingIndicator />;
    }

    return (
      <Layout>
        <Suspense fallback={ <LoadingIndicator /> }>
          <Switch>
            <Route exact path="/">
              <Redirect to="/login" />
            </Route>
            <Route path="/login" component={ LoginLayout } />
            <Route path="/login-v2" component={ LoginV2 } />
            <Route path="/oauth/callback" component={ OAuthCallback } />
            <Route path="/sign-up-success" component={ SignupSuccess } />
            <Route path="/activate" component={ ActiveAccount } />
            <Route path="/create-org" component={ CreateOrg } />
            <Route path="/invite/accept/:id" component={ AcceptInvite } />
            <Route path="/change-email" component={ ChangeEmail } />
            <Route path="/change-password" component={ ChangePassword } />
            <Route path="/forgot-password" component={ ForgotPassWord } />
            { allowRegister && <Route path="/signup" component={ Signup } /> }
            { allow2Oauth && (
              <Route path="/oauth2/redirect" component={ OAuth2RedirectHandler } />
            ) }
            <Route component={ NotFound } />
          </Switch>
        </Suspense>
      </Layout>
    );
  }
}

export default App;
